import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { DESTINATIONS_INDIA, DESTINATIONS_WORLD } from '../data/mock';

const Card = ({ d, large }) => (
  <Link to="/plan" className="group block">
    <div className={`relative overflow-hidden ${large ? 'aspect-[16/10]' : 'aspect-[4/5]'}`}>
      <img src={d.image} alt={d.name} className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#053e49]/90 via-[#053e49]/20 to-transparent" />
      <div className="absolute bottom-0 inset-x-0 p-6 text-[#faf4ea]">
        <div className="eyebrow text-[#c3a66d]">{d.tag || d.country}</div>
        <div className="font-serif text-3xl mt-1">{d.name}</div>
      </div>
    </div>
  </Link>
);

export default function Destinations() {
  return (
    <main className="pt-32">
      <section className="max-w-[1340px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>Destinations</SectionLabel>
        <Heading className="mt-5 font-serif max-w-4xl">Where will <span className="italic">your story</span> take you?</Heading>
        <p className="mt-6 max-w-2xl text-[#4a5c60] text-lg leading-relaxed">From royal palaces in Rajasthan to sunset cliffs in Santorini — every Sunday Mirror destination is chosen for the way it carries a wedding week.</p>
      </section>

      <section className="max-w-[1340px] mx-auto px-6 md:px-10 pb-20">
        <h2 className="font-serif text-4xl text-[#053e49]">India</h2>
        <div className="hairline mt-4 w-20" />
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {DESTINATIONS_INDIA.map((d) => <Card key={d.name} d={d} />)}
        </div>
      </section>

      <section className="bg-[#fbf8f2] py-20">
        <div className="max-w-[1340px] mx-auto px-6 md:px-10">
          <h2 className="font-serif text-4xl text-[#053e49]">Around the World</h2>
          <div className="hairline mt-4 w-20" />
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {DESTINATIONS_WORLD.map((d) => <Card key={d.name} d={d} />)}
          </div>
        </div>
      </section>

      <section className="max-w-[900px] mx-auto px-6 md:px-10 py-24 text-center">
        <SectionLabel align="center">Destination Finder</SectionLabel>
        <Heading className="mt-5 font-serif">Not sure where to <span className="italic">get married?</span></Heading>
        <p className="mt-6 text-[#4a5c60]">Tell us your guest count, preferred season, approximate budget, wedding style, where guests will travel from and what matters most. We’ll recommend destinations suited to your celebration.</p>
        <Link to="/plan" className="btn-gold mt-8">Find My Wedding Destination <ArrowRight size={16} /></Link>
      </section>

      <CTABanner />
    </main>
  );
}
